// Sentry.io error monitoring initialization for ZeroMargin frontend.
// Activated only when all three are true: production build + env flag + DSN.
import * as Sentry from "@sentry/react";

const isProd = process.env.NODE_ENV === "production";
const enabled = process.env.REACT_APP_SENTRY_ENABLED === "true";
const dsn = process.env.REACT_APP_SENTRY_DSN;

export const initSentry = () => {
  if (!(isProd && enabled && dsn)) return;
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "production",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0.05),
    // Don't capture personally identifiable headers/cookies by default; we attach user via setUser instead.
    sendDefaultPii: false,
    // Filter out noisy/expected errors.
    beforeSend(event, hint) {
      const err = hint?.originalException;
      const msg = (err && err.message) || event.message || "";
      // Network/cancel errors from logged-out 401s — already handled gracefully.
      if (/401|Network Error|Request aborted|canceled/i.test(msg)) return null;
      return event;
    },
  });
};

export const setSentryUser = (user) => {
  if (!(isProd && enabled && dsn)) return;
  if (user && user.user_id) {
    Sentry.setUser({ id: String(user.user_id), email: user.email || undefined });
  } else {
    Sentry.setUser(null);
  }
};

export { Sentry };
